import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow",
  "use": "icon-arrow-usage",
  "viewBox": "0 0 100 90",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 90\" id=\"icon-arrow\">\r\n    <style>#icon-arrow .a{fill:#FFF;}</style>\r\n    <title>  Page 1</title>\r\n    <desc>Arrow</desc>\r\n    <g class=\"a\">\r\n        <path d=\"M50.5 56C53.3 53.2 56.2 50.4 59 47.6L57.7 46.3 51.4 52.5 51.4 35 49.6 35 49.6 52.5 43.3 46.3 42 47.6\" />\r\n    </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/arrow.svg
// module id = 264
// module chunks = 0 1